import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "page",
  ref: "pageRef"
}
const _hoisted_2 = { class: "page_wrap" }
const _hoisted_3 = {
  key: 0,
  class: "item1"
}
const _hoisted_4 = { class: "core_content" }
const _hoisted_5 = { class: "core_title" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "core_icon" }
const _hoisted_9 = { class: "item_img" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "item_title" }
const _hoisted_12 = { class: "core_pic" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "item1" }
const _hoisted_16 = { class: "core_content" }
const _hoisted_17 = { class: "core_title" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "core_pic" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  class: "core_icon",
  style: {"padding":"0px 44px","display":"flex","justify-content":"space-around"}
}
const _hoisted_23 = { class: "item_img" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "item_title" }
const _hoisted_26 = {
  class: "item1",
  style: {"margin-top":"58px","width":"1200px"}
}
const _hoisted_27 = { class: "core_pic" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "item1" }
const _hoisted_31 = { class: "core_content" }
const _hoisted_32 = { class: "core_title" }
const _hoisted_33 = ["src"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "core_pic" }
const _hoisted_36 = ["src"]
const _hoisted_37 = {
  class: "core_icon",
  style: {"padding":"0px 44px 32px","display":"flex","justify-content":"space-between"}
}
const _hoisted_38 = { class: "item_img" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "item_title" }
const _hoisted_41 = { key: 3 }
const _hoisted_42 = { class: "item1" }
const _hoisted_43 = { class: "core_content" }
const _hoisted_44 = { class: "core_title" }
const _hoisted_45 = ["src"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { class: "core_pic" }
const _hoisted_48 = ["src"]
const _hoisted_49 = {
  class: "core_icon",
  style: {"padding":"0px 44px 32px","display":"flex","justify-content":"space-around"}
}
const _hoisted_50 = { class: "item_img" }
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "item_title" }
const _hoisted_53 = {
  key: 4,
  class: "item1"
}
const _hoisted_54 = { class: "core_content" }
const _hoisted_55 = { class: "core_title" }
const _hoisted_56 = ["src"]
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { class: "core_icon" }
const _hoisted_59 = { class: "item_img" }
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "item_title" }
const _hoisted_62 = { class: "core_pic" }
const _hoisted_63 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "page_top_bg" }, [
      _createElementVNode("img", { src: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934953643/core_top_bg.png" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coreList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "core_item",
          ref_for: true,
          ref: "coreRef",
          key: index
        }, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"background":"#f4f6f7","height":"74px"} }, null, -1)),
          (index == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: item.icon
                    }, null, 8, _hoisted_6),
                    _createElementVNode("span", {
                      innerHTML: item.title
                    }, null, 8, _hoisted_7)
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "core_text" }, " 对建设项目全生命周期提供组织 、管理、经济和技术等各有关方面的工程咨询服务。包括项目的全过程管理以及投资咨询、勘察、设计、造价咨询、招标代理、监理、运行维护咨询等工程建设项目各阶段专业咨询服务。提供从项目策划、设计、施工到投运及后续维护等全方位的咨询服务，确保不同阶段的工作协调一致。 ", -1)),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "core_text" }, " 我们拥有一支专业的技术团队，熟悉各类工程的规划、设计、建设和管理要求，能够提供建议和解决方案。在多年的实践中积累了丰富的经验和案例，能够通过优化设计和施工流程、降低成本、提高效率和品质等方面实现精益化管理。预测和识别可能存在的问题和隐患，并制定相应的措施和预案，以减少项目实施过程中的风险和不确定性，加强项目管理，降低成本，提高效率和品质，最大限度地提高项目收益。 ", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.serveList, (label, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "icon_item icon_5",
                        key: idx
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("img", {
                            src: label.icon
                          }, null, 8, _hoisted_10)
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(label.title), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: item.pic
                  }, null, 8, _hoisted_13)
                ])
              ]))
            : _createCommentVNode("", true),
          (index == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("img", {
                        src: item.icon
                      }, null, 8, _hoisted_18),
                      _createElementVNode("span", {
                        innerHTML: item.title
                      }, null, 8, _hoisted_19)
                    ]),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "core_text" }, [
                      _createTextVNode(" 1、建设项目投资估算的编制、审核及项目经济评价；"),
                      _createElementVNode("br"),
                      _createTextVNode(" 2、工程概算、预算、结算、竣工决算、工程招标标底价、投标报价的编制、审核；"),
                      _createElementVNode("br"),
                      _createTextVNode(" 3、工程变更及合同价款的调整和索赔费用的计算；"),
                      _createElementVNode("br"),
                      _createTextVNode(" 4、建设项目各阶段的工程造价控制；"),
                      _createElementVNode("br"),
                      _createTextVNode(" 5、工程经济纠纷的鉴定；"),
                      _createElementVNode("br"),
                      _createTextVNode(" 6、工程造价计价依据的编制、审核；"),
                      _createElementVNode("br"),
                      _createTextVNode(" 7、与工程造价业务有关的其他事项。"),
                      _createElementVNode("br")
                    ], -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "core_text" }, " 企业内部建立了系统性与一致性的组织体系及工作流程，确保组织体系与工作体系的完整性。提供涵盖项目决策、设计、招投标、施工、竣工结算及后期审计等一系列服务的过程。通过系统化、专业化的方法，实现对项目成本的有效控制和优化。 ", -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "core_text" }, " 强调与项目各参与方（如业主、设计师、承包商等）之间的紧密合作与沟通，通过建立有效的信息共享机制和协调平台，促进各方之间的协作效率，避免信息孤岛现象的发生。熟悉并遵守国家及地方关于建设工程领域的相关法律法规及标准规范要求, 确保所有操作流程合法合规且具有较高的透明度。 ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("img", {
                      src: item.pic
                    }, null, 8, _hoisted_21)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.serveList, (label, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "icon_item icon_6",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("img", {
                          src: label.icon
                        }, null, 8, _hoisted_24)
                      ]),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(label.title), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("img", {
                      src: item.pic2
                    }, null, 8, _hoisted_28)
                  ]),
                  _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"person_left\" data-v-9efa7c32><div class=\"person_title\" data-v-9efa7c32>公司现有专业造价人员</div><div class=\"person_img\" data-v-9efa7c32><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935299598/person_img1.png\" alt=\"\" data-v-9efa7c32><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935319303/person_img2.png\" alt=\"\" data-v-9efa7c32></div><div class=\"person_text\" data-v-9efa7c32> 人员具备深厚的造价管理专业知识，了解成本核算、预算编制和项目估算等各个方面的专业知识和技能；可以通过合理的成本控制和预算管理，为项目的顺利进行提供支持。 </div><div class=\"person_text\" data-v-9efa7c32> 在造价管理领域具有较长时间的从业经验，能够应对各类项目的造价管理挑战；熟悉市场行情和政策法规，能够快速准确地为业主提供专业建议能够准确分析项目成本结构，为企业提供具有实际意义的预算和投资建议。 </div></div>", 1))
                ])
              ]))
            : _createCommentVNode("", true),
          (index == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("img", {
                        src: item.icon
                      }, null, 8, _hoisted_33),
                      _createElementVNode("span", {
                        innerHTML: item.title
                      }, null, 8, _hoisted_34)
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "core_text" }, " 主要从事各类工程、物资、设备、服务等招标代理业务，包括政府采购代理、工程招标代理、物资采购代理等。我司自成立以来，累计完成各类招标代理项目数千项，涉及工程建设、政府采购、科研、金融等多个领域。在长期的业务实践中，我们积累了丰富的行业经验，能够为客户提供专业、高效的招标代理服务 ", -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "core_text" }, " 我司建立了完善的招标体系，包括招标策划、招标文件编制、招标公告发布、投标人资格审查、开标、评标、中标公示等环节。在招标过程中，我们严格按照法律法规和招标文件的要求，确保招标过程的公开、公平、公正。高度重视招标项目的保密工作，建立健全保密制度，确保招标信息的安全。在招标过程中，我们对招标文件、评标结果等敏感信息进行严格保密，确保招标活动的顺利进行。 ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("img", {
                      src: item.pic
                    }, null, 8, _hoisted_36)
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.serveList, (label, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "icon_item icon_5",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("img", {
                          src: label.icon
                        }, null, 8, _hoisted_39)
                      ]),
                      _createElementVNode("div", _hoisted_40, _toDisplayString(label.title), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (index == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("img", {
                        src: item.icon
                      }, null, 8, _hoisted_45),
                      _createElementVNode("span", {
                        innerHTML: item.title
                      }, null, 8, _hoisted_46)
                    ]),
                    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"core_text\" data-v-9efa7c32> 开展相应资质等级类别的建设工程的项目管理、技术咨询等业务。已涵盖工程建设服务的所有范围，从工程投资风险收益预测，市场预测，至招投标，前期手续代理，工程建设监理，工程造价咨询等，已形成综合优势。这些服务将为您带来费用上的很大节约，手续上的简化，同时更重要是使您的工程有一个完整、规范的、全局性的运作，这比各部分分散操作大大节约了资金、人力、物力及时间。 </div><div style=\"margin-top:32px;display:flex;justify-content:space-between;\" data-v-9efa7c32><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935716259/person_img3.png\" alt=\"\" data-v-9efa7c32><img src=\"https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935716290/person_img4.png\" alt=\"\" data-v-9efa7c32></div><div class=\"core_text\" data-v-9efa7c32> 中致远现有注册全国监理工程师 45 人、其他专业监理从业人员 50 余人，注册专业涵盖房屋建筑工程、化工石油工程、水利水电工程、电力工程、公路工程、通信工程、市政公用工程、机电安装工程等。特别成立业务专家组，专家组包含国家级监理工程师，国家造价工程师，电气工程专家，地基与基础工程专家，装饰工程专家、测绘工程专家等。这些专家在关键部位为您们把关，审查重大技术方案等，他们可以其多年丰富的经验和扎实的理论为您排忧解难。 </div><div class=\"core_text\" data-v-9efa7c32> 监理人员的不规范行为可能会给业主造成不利局面，因此，建立完整规范的廉洁监督体制是极为重要的。我司拥有二级监督机制，第一级为建立业主廉洁联系卡，定期回访业主，由业主协助监督。第二级为本司监理部检查监督，定期汇同工地总监，部门领导检查、评比。 </div>", 4))
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("img", {
                      src: item.pic
                    }, null, 8, _hoisted_48)
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.serveList, (label, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "icon_item icon_6",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("img", {
                          src: label.icon
                        }, null, 8, _hoisted_51)
                      ]),
                      _createElementVNode("div", _hoisted_52, _toDisplayString(label.title), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (index == 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("img", {
                      src: item.icon
                    }, null, 8, _hoisted_56),
                    _createElementVNode("span", {
                      innerHTML: item.title
                    }, null, 8, _hoisted_57)
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "core_text" }, " 开展相应资质等级类别的建设工程的项目管理、技术咨询等业务。通过运用综合项目管理知识、技能、工具和技术，对项目活动进行有效的启动、规划、执行、监控、和收尾，确保项目按照既定目标顺利完成。 ", -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "core_text" }, " 通过全面风险识别、评估，制定和执行应对计划，有效降低项目风险，保障项目顺利进行。可预测和识别可能存在的问题和隐患，并制定相应的措施和预案，以减少项目实施过程中的风险和不确定性。 ", -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "core_text" }, " 与客户的持续沟通和交流，及时了解客户的需求变化，相应调整项目计划，确保项目成果符合客户的最新需求并确保项目成果满足甚至超过客户期望。全面分析项目、资源需求和资源状况，通过对现有资源的评估和分配，协助业主、项目管理对象实现项目资源的最优配置。 ", -1)),
                  _createElementVNode("div", _hoisted_58, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.serveList, (label, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "icon_item icon_4",
                        key: idx
                      }, [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("img", {
                            src: label.icon
                          }, null, 8, _hoisted_60)
                        ]),
                        _createElementVNode("div", _hoisted_61, _toDisplayString(label.title), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("img", {
                    src: item.pic
                  }, null, 8, _hoisted_63)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 512))
}